import LegalLayout, { LegalSection, LegalList } from "./LegalLayout";

export default function Cookies() {
  return (
    <LegalLayout
      testid="legal-cookies-page"
      kicker="Legal"
      title="Cookie Policy"
      lastUpdated="28 February 2026"
      intro="This policy explains what cookies CanniComply uses, why we use them and how you can control them. We take a minimal-cookie approach — nothing runs on your device unless it is genuinely required to make the platform work or to keep it reliable."
    >
      <LegalSection number="01" title="What is a cookie?" testid="legal-cookies-intro">
        <p>
          A cookie is a small text file placed on your device when you visit
          a website. It lets a site remember information about your session
          — for example, keeping you signed in as you move between pages.
        </p>
      </LegalSection>

      <LegalSection number="02" title="Which cookies we use">
        <p>We use only two categories:</p>
        <LegalList
          items={[
            "Strictly necessary — a session cookie carrying your authentication token so the platform recognises you between pages. Without it, you'd need to sign in on every click.",
            "Product analytics — an anonymised PostHog cookie that measures which features are used and where errors occur. This is used only to keep the platform reliable and to prioritise improvements. It does not identify you personally.",
          ]}
        />
        <p>
          We do not use advertising cookies. We do not sell cookie data. We
          do not embed third-party trackers on any page inside the customer
          dashboard.
        </p>
      </LegalSection>

      <LegalSection number="03" title="Controlling cookies">
        <p>
          You can clear cookies via your browser at any time. Most browsers
          let you block cookies per site — however, blocking the
          strictly-necessary cookie means the platform cannot keep you
          signed in and the app will not function.
        </p>
      </LegalSection>

      <LegalSection number="04" title="Do Not Track">
        <p>
          We respect Do Not Track signals for the analytics cookie: if your
          browser sends DNT, we do not initialise product analytics for
          your session.
        </p>
      </LegalSection>

      <LegalSection number="05" title="Changes to this policy">
        <p>
          If we introduce new cookies we'll update this page and, where
          they're non-essential, ask for your consent before they run.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
